import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUserTasksService } from "services/UserTasksService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  UserTaskStatusTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
};

export const userTaskStatusTypeSelectSlice = createSlice({
  name: "userTaskStatusTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserTaskStatusTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getUserTaskStatusTypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getUserTaskStatusTypeSelectModels.fulfilled, (state, action) => {
        state.UserTaskStatusTypeSelectModels = action.payload;
        state.Loading = false;
      });
  },
});

export const getUserTaskStatusTypeSelectModels = createAsyncThunk(
  "UserTaskStatusTypeSelect/GetUserTaskStatusTypeSelectModels",
  async () => {
    const userTasksService = container.get<IUserTasksService>(SERVICE_TYPES.UserTasksService);
    return await userTasksService.getUserTaskStatusTypeSelectModels();
  }
);

export const selectUserTaskStatusTypeSelectModels = (state: RootState) => {
  return state.userTaskStatusTypeSelect.UserTaskStatusTypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.userTaskStatusTypeSelect.Loading;
};

export default userTaskStatusTypeSelectSlice.reducer;
